<!-- /* [MP-MATCH-SEND-TAB] 나의 매칭현황 - 보낸 신청서 */ -->

<template>
  <my-matching></my-matching>
</template>

<script>
import MyMatching from "@/components/matching/MyMatching.vue";
export default {
  name: "MyMatching",
  components: {
    "my-matching": MyMatching,
  },
  data() {
    return {};
  },
};
</script>
